import { render, staticRenderFns } from "./salesOrderInformation.vue?vue&type=template&id=30f97049&scoped=true"
import script from "./salesOrderInformation.vue?vue&type=script&lang=js"
export * from "./salesOrderInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f97049",
  null
  
)

export default component.exports